<template>
  <div class="child-Page">
    <childNav :routerName="$t('elevator.title')" :backFlag="true"></childNav>
    <div class="modules-container">
      <!-- 上传模块 -->
      <div class="module">
        <div class="module-header" v-if="uploadStatus === 'waiting'">
          <Upload type="drag" :before-upload="handleSuccess" action="/">
            <div class="drag-box">
              <h2>{{ $t("elevator.label") }}</h2>
              <Icon size="148" type="md-cloud-upload" />
              <!-- 点击或拖拽文件到此处上传 -->
              <h3>{{ $t("elevator.uploadTip") }}</h3>
            </div>
          </Upload>
        </div>
        <!-- 成功 -->
        <div class="module-header" v-else-if="uploadStatus === 'success'">
          <h2>{{ $t("elevator.label") }}</h2>
          <Icon size="148" type="md-cloud-upload" />
          <h3>
            {{ $t("elevator.fileLabel") + outputJsonName }}
          </h3>
          <h3>{{ $t("elevator.tip") }}</h3>
        </div>
        <!-- 报错 -->
        <div class="module-header" v-else-if="uploadStatus === 'error'">
          <h2>{{ $t("elevator.label") }}</h2>
          <Icon size="148" type="md-cloud-upload" />
          <h3 class="error">
            <Icon type="md-alert" />{{ $t("elevator.error" + errorType) }}
          </h3>
        </div>
        <div
          class="module-foot"
          v-if="uploadStatus === 'waiting' || uploadStatus === 'error'"
        >
          <Button type="primary" size="large" shape="circle" class="w-50 file"
            >{{ $t("elevator.upload") }}
            <input
              ref="fileInput"
              type="file"
              @change="handleBtnUpload($event)"
            />
          </Button>
        </div>
        <!-- 成功 -->
        <div class="module-foot" v-else>
          <Button
            type="primary"
            size="large"
            shape="circle"
            class="w-50"
            @click="outputJson"
            >{{ $t("elevator.downloadfile") }}</Button
          >
        </div>
      </div>
      <!-- 下载模板模块 -->
      <div class="module">
        <div class="module-header">
          <div class="drag-box">
            <h2>{{ $t("elevator.download") }}</h2>
            <Icon
              size="148"
              type="md-cloud-download"
              @click="downloadTemplate"
            />
            <a @click="downloadTemplate">
              <h3>{{ $t("elevator.generate") }}</h3></a
            >
          </div>
        </div>

        <div class="module-foot">
          <Button
            type="primary"
            size="large"
            shape="circle"
            class="w-50"
            @click="downloadTemplate"
          >
            {{ $t("elevator.downloadTip") }}
          </Button>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import childNav from "@/components/homeNav/childNav.vue";
import { getLanguage } from "@/utils/auth";
import XLSX from "xlsx";
export default {
  name: "openList",
  components: {
    childNav,
  },
  data() {
    return {
      addForm: {},
      ruleValidate: {},
      fileUrl: process.env.BASE_URL + "梯控配置文件.xlsx",
      uploadStatus: "waiting", // 上传状态 waiting/success/error
      errorType: "1", // 错误类型
      outputObject: {},
      outputJsonName: "elevatorConfig.json",
    };
  },
  watch: {},
  mounted() {},
  methods: {
    // 校验文件格式
    handleFormatError(file) {
      let lastName = file.name.split(".").reverse()[0];
      let allowReg = ["xlsx", "XLSX", "xls", "XLS"];
      if (!allowReg.includes(lastName)) {
        this.$Message.error(this.$t("elevator.formatError"));
        this.$refs.fileInput.value = null;
        return false;
      }
      return true;
    },
    // 按钮上传文件
    handleBtnUpload($event) {
      let el = $event.currentTarget;
      this.handleSuccess(el.files[0]);
    },
    // 上传并解析文件
    handleSuccess(file) {
      // 重置上传状态
      this.uploadStatus = "waiting";
      // 校验文件格式
      const fileFormat = this.handleFormatError(file);
      if (!fileFormat) {
        return false;
      }
      const reader = new FileReader();
      reader.onload = (ev) => {
        try {
          const data = new Uint8Array(ev.target.result);
          const workbook = XLSX.read(data, { type: "array" });
          // 解析第一个工作表
          const firstResult = XLSX.utils.sheet_to_json(
            workbook.Sheets[workbook.SheetNames[0]],
            { header: 1 }
          );
          const floorArray = this.verifyFirst(firstResult);

          // 解析第二个工作表
          const secondResult = XLSX.utils.sheet_to_json(
            workbook.Sheets[workbook.SheetNames[1]],
            { header: 1 }
          );
          const gatewayArray = this.verifySecond(secondResult);

          // 解析第三个工作表
          const thirdResult = XLSX.utils.sheet_to_json(
            workbook.Sheets[workbook.SheetNames[2]],
            { header: 1 }
          );
          const deviceArray = this.verifyThird(thirdResult);

          // 输出结果组合
          this.outputObject = {
            ["floor_mapping"]: floorArray,
            ["gateway_lift_mapping"]: gatewayArray,
            ["device_floor_mapping"]: deviceArray,
          };

          // 设置上传成功状态
          if (this.uploadStatus !== "error") {
            this.uploadStatus = "success";
          }
        } catch (error) {
          console.error("解析 Excel 失败:", error);
        } finally {
          // 释放文件输入框的值，允许上传同一个文件
          this.$refs.fileInput.value = null;
        }
      };

      // 9. 以 ArrayBuffer 的方式读取文件
      reader.readAsArrayBuffer(file);
    },
    // 验证第一个表格内容
    verifyFirst(firstResult) {
      const result = firstResult.slice(5, 77);

      let firstRow = [];
      let secondRow = [];
      let floorArray = [];
      result.map((item) => {
        // 物理层数 显示层数 完整输入校验
        if (item[0] === undefined && item[1]) {
          this.setErrorStatus("1");
          return false;
        }
        if (item[1] === undefined && item[0]) {
          this.setErrorStatus("2");
          return false;
        }
        // 都为空 跳过 允许空行
        if (item[0] === undefined && item[1] === undefined) {
          return false;
        }
        // 物理层数 显示层数 输入重复校验
        if (firstRow.includes(item[0])) {
          this.setErrorStatus("1");
          return false;
        }
        if (secondRow.includes(item[1])) {
          this.setErrorStatus("2");
          return false;
        }
        // 单项输入校验
        let isValidPhysical = this.validateInter(item[0]);
        let isValidDisplay = this.validateFloor(item[1]);
        if (!isValidPhysical) {
          this.setErrorStatus("1");
          return false;
        }

        if (!isValidDisplay) {
          this.setErrorStatus("2");
          return false;
        }

        // 通过校验 添加到数组
        if (item[0] !== undefined && item[1] !== undefined) {
          firstRow.push(item[0]);
          secondRow.push(item[1]);
          floorArray.push({ physical: item[0], display: item[1] });
        }
      });

      if (this.uploadStatus !== "error") {
        return floorArray;
      } else {
        return [];
      }
    },

    validateInter(value) {
      // 1. 检查是否为数字类型
      if (typeof value !== "number") {
        return false;
      }
      // 2. 检查是否为整数
      if (!Number.isInteger(value)) {
        return false;
      }
      // 3. 检查范围 [-8, 64] 且 不等于 0
      return value >= -8 && value <= 64 && value !== 0;
    },

    validateFloor(value) {
      // 允许字母和数字组合
      const regex = /^[a-zA-Z0-9]+$/;
      return regex.test(value);
    },
    // 设置错误状态
    setErrorStatus(type) {
      this.uploadStatus = "error";
      this.errorType = type;
    },

    // 验证第二个表格内容
    verifySecond(secondResult) {
      const result = secondResult.slice(5);

      let gatewayArray = [];
      result.map((item) => {
        // 网关地址 显示梯号 完整输入校验
        if (item[0] === undefined && item[1]) {
          this.setErrorStatus("3");
          return false;
        }
        if (item[1] === undefined && item[0]) {
          this.setErrorStatus("4");
          return false;
        }
        // 都为空 跳过 允许空行
        if (item[0] === undefined && item[1] === undefined) {
          return false;
        }
        // 单项输入校验
        let isValidIp = this.validateIP(item[0]);
        let isValidLift = this.validateStair(item[1]);
        if (!isValidIp) {
          this.setErrorStatus("3");
          return false;
        }

        if (!isValidLift) {
          this.setErrorStatus("4");
          return false;
        }

        // 通过校验 添加到数组
        if (item[0] !== undefined && item[1] !== undefined) {
          gatewayArray.push({ ["gateway_ip"]: item[0], ["lift_no"]: item[1] });
        }
      });
      // 控制网关数量不超过4个
      if (this.uploadStatus !== "error" && gatewayArray.length < 5) {
        return gatewayArray;
      } else if (gatewayArray.length >= 5) {
        this.setErrorStatus("6");
        return [];
      } else {
        return [];
      }
    },

    validateIP(ip) {
      // 1. 基础检查：是否为空或格式不对
      if (!ip || !ip.toString().includes(".")) return false;

      const parts = ip.split(".");

      // 必须有且仅有4段
      if (parts.length !== 4) return false;

      for (let part of parts) {
        // 检查是否为数字
        if (!/^\d+$/.test(part)) return false;

        // 转为数字
        const num = Number(part);

        // 检查范围
        if (num < 0 || num > 255) return false;

        // 防止前导零，如 "01"、"001" (可选，视业务需求而定)
        if (part.length > 1 && part[0] === "0") return false;
      }

      return true;
    },

    validateStair(value) {
      // 允许中文、字母和数字组合
      const regex = /^[\u4e00-\u9fa5a-zA-Z0-9]+$/;
      return regex.test(value);
    },

    // 验证第三个表格内容
    verifyThird(thirdResult) {
      const result = thirdResult.slice(5);
      let firstRow = [];
      let deviceArray = [];
      result.map((item) => {
        // 设备ip 物理楼层 完整输入校验
        if (item[0] === undefined && item[1]) {
          this.setErrorStatus("5");
          return false;
        }
        if (item[1] === undefined && item[0]) {
          this.setErrorStatus("1");
          return false;
        }
        // 都为空 跳过 允许空行
        if (item[0] === undefined && item[1] === undefined) {
          return false;
        }
        // 物理层数 显示层数 输入重复校验
        if (firstRow.includes(item[0])) {
          this.setErrorStatus("5");
          return false;
        }
        // 单项输入校验
        let isValidIp = this.validateIP(item[0]);
        let isValidPhysical = this.validateInter(item[1]);
        if (!isValidIp) {
          this.setErrorStatus("5");
          return false;
        }

        if (!isValidPhysical) {
          this.setErrorStatus("1");
          return false;
        }

        // 通过校验 添加到数组
        if (item[0] !== undefined && item[1] !== undefined) {
          firstRow.push(item[0]);
          deviceArray.push({
            ["device_ip"]: item[0],
            ["physical_floor"]: item[1],
          });
        }
      });

      if (this.uploadStatus !== "error") {
        return deviceArray;
      } else {
        return [];
      }
    },
    // 输出 JSON 文件的逻辑
    outputJson() {
      const fileStr = JSON.stringify(this.outputObject, null, 2); // 美化格式
      let export_blob = new Blob([fileStr]);
      let downloadElement = document.createElement("a");
      let href = window.URL.createObjectURL(export_blob);
      downloadElement.href = href;
      downloadElement.download = this.outputJsonName; // 下载后文件名
      document.body.appendChild(downloadElement);
      downloadElement.click(); // 点击下载
      document.body.removeChild(downloadElement); // 下载完成移除元素
      window.URL.revokeObjectURL(href); // 释放掉blob对象
      this.outputObject = {}; // 重置输出对象
    },
    // 下载模板文件
    downloadTemplate() {
      const lang = getLanguage();
      let fileUrl;
      if (lang === "zh_CN") {
        fileUrl = process.env.BASE_URL + "梯控配置文件.xlsx";
      } else {
        fileUrl =
          process.env.BASE_URL + "Elevator_Control_Configuration_File.xlsx";
      }

      let downloadElement = document.createElement("a");
      downloadElement.href = fileUrl;
      downloadElement.download = this.$t("elevator.fileName"); // 下载后文件名
      document.body.appendChild(downloadElement);
      downloadElement.click(); // 点击下载
      document.body.removeChild(downloadElement); // 下载完成移除元素
    },
  },
};
</script>

<style lang="scss" scoped>
/* 模块容器 */
.modules-container {
  width: 100%;
  display: flex;
  align-items: center;
  justify-content: center;
  gap: 30px;
  flex-wrap: wrap;

  .module {
    width: 600px;
    height: 400px;
    background: white;
    border-radius: 16px;
    overflow: hidden;
    box-shadow: 0 10px 25px rgba(0, 0, 0, 0.08);
    transition: transform 0.3s ease, box-shadow 0.3s ease;
    display: flex;
    flex-direction: column;
  }
  .module:hover {
    transform: translateY(-5px);
    box-shadow: 0 15px 35px rgba(0, 0, 0, 0.12);
  }
  /* 模块头部 - 蓝色渐变 */
  .module-header {
    flex: 1;
    background: linear-gradient(to bottom, #0f75ff 0%, #ffffff 100%);
    color: white;
    padding: 25px;
    text-align: center;
    .error {
      color: #ed4014;
      font-weight: 400;
    }
    .drag-box {
      padding: 12px;
    }
  }

  .module-header h2 {
    font-size: 24px;
    font-weight: 600;
    margin-bottom: 5px;
  }
  .module-header h3 {
    color: black;
    font-size: 18px;
    font-weight: 600;
    margin-bottom: 5px;
    overflow: hidden; /* 超出部分隐藏 */
    text-overflow: ellipsis; /* 显示省略号 */
    white-space: nowrap; /* 不换行 */
    width: 100%;
  }

  .module-foot {
    height: 80px;
    display: flex;
    justify-content: center;
    align-items: center;
    .file {
      position: relative;
      display: inline-block;
      overflow: hidden;
      text-align: center;
    }

    .file input {
      position: absolute;
      width: 100%;
      height: 100%;
      right: 0;
      top: 0;
      opacity: 0;
    }
  }
}

/* 响应式设计 */
@media (max-width: 768px) {
  .modules-container {
    flex-direction: column;
    align-items: center;
  }

  .module {
    width: 100%;
    max-width: 100%;
  }

  .header h1 {
    font-size: 26px;
  }
}

.w-100 {
  width: 100%;
}
.w-50 {
  width: 50%;
}
</style>
